import React from 'react';
import { FriendProfile } from './FriendProfile.js';

export class Friends extends React.Component {
  constructor(props) {
    super(props);
    this.state = { people: [], isOpen: false, selectedProfile: null }; // Add selectedProfile
    this.takeData = this.takeData.bind(this);
    this.update = this.update.bind(this);
    this.showProfile = this.showProfile.bind(this); // Bind showProfile
  }

  takeData() {
    // Mock data (replace with your actual data fetching)
    const data = [
      { name: "Alice", imagesrcs: "alice.jpg" },
      { name: "Bob", imagesrcs: "bob.png" },
      { name: "Charlie", imagesrcs: "charlie.gif" },
    ];
    return data;
  }

  update() {
    const data = this.takeData();
    this.setState({ people: data });
  }

  componentDidMount() {
    this.update();
  }

  showProfile(profile) {
    this.setState({ isOpen: true, selectedProfile: profile }); // Set selectedProfile
  }

  handleProfileClose() {
    this.setState({ isOpen: false, selectedProfile: null }); // Also reset selectedProfile
  }
  render() {
    if (this.state.people.length === 0) {
      return <div>Loading...</div>;
    }

    if (!this.state.isOpen) { // Use ! for boolean check
      return (
        <div>
          <div class="w-full max-w-full  lg-max:mt-6 xl:w-12/12 ">
            <div class="relative flex flex-col h-full min-w-0 break-words bg-white border-0  dark:shadow-dark-xl rounded-2xl bg-clip-border">
              <div class="pb-0 mb-0 border-b-0 rounded-t-2xl">
              <h6 class="block antialiased tracking-normal font-sans text-base font-semibold leading-relaxed text-blue-gray-900">Connection</h6>
              </div>
              <div class="flex-auto p-2 ">
                <ul class="flex flex-col pl-0 mb-0 rounded-lg">
               
     
          {this.state.people.map((person, index) => (
            
            <div key={index} onClick={() => this.showProfile(person)}> {/* Click handler */}
                <li class="relative flex items-center px-0 py-2 border-0 rounded-t-lg ">
                   
                    <div class="flex flex-col items-start justify-center">
                      <h6 class="mb-0 text-sm leading-normal dark:text-white"> {person.name} {/* Display person's name */}</h6>
                      <p class="mb-0 text-xs leading-tight dark:text-white dark:opacity-60">Hi! I need more information..</p>
                    
                    </div>
                    <div class="inline-flex items-center justify-center w-12 h-12 mr-4 text-base text-white transition-all duration-200 ease-in-out rounded-xl">
                      <img src="../../../assets/img/kal-visuals-square.jpg" alt="kal" class="w-full shadow-2xl rounded-xl"/>
                    </div>
                  </li>
             
            </div>
          ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
     
      return (
      <div id="hello"  class="z-20 fixed top-0 left-0 bg-black/40 w-screen h-screen" onClick={() =>  this.setState({ isOpen: false})}><FriendProfile profile={this.state.selectedProfile} Close={this.handleProfileClose}/>; // Pass selectedProfile
    </div>);
    }
  }
}